import { Pipe, PipeTransform } from '@angular/core';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { COUNTRIES } from '../components/phone-input/countries.data';

@Pipe({
  name: 'phoneNumberDisplay',
  standalone: false
})
export class PhoneNumberDisplayPipe implements PipeTransform {
  private readonly phoneUtil = PhoneNumberUtil.getInstance();

  transform(phoneNumber: string): string {
    if (!phoneNumber) {
      return '';
    }

    // Plain 10-digit US number → (XXX) XXX-XXXX
    if (/^\d{10}$/.test(phoneNumber)) {
      return `(${phoneNumber.substring(0, 3)}) ${phoneNumber.substring(
        3,
        6
      )}-${phoneNumber.substring(6, 10)}`;
    }

    // Non-US numbers are stored in international format (e.g. '+44 20 7946 0958').
    // Format them as CountryCode-PhoneNumber using libphonenumber.
    try {
      const parsed = this.phoneUtil.parse(phoneNumber);
      const callingCode = String(parsed.getCountryCode());

      // Derive the national portion from the original input's digits rather than
      // parsed.getNationalNumber(), which is numeric and would drop significant
      // leading zeros for some countries (e.g. Italy '+39 02 …').
      const inputDigits = phoneNumber.replace(/\D/g, '');
      let nationalNumber = inputDigits.startsWith(callingCode)
        ? inputDigits.slice(callingCode.length)
        : (parsed.getNationalNumber()?.toString() ?? '');

      // For NANP territories the display dial code includes an area code that is
      // part of the national number (e.g. American Samoa '1684' = code 1 + 684).
      // Use the full dial code and strip the area code from the national number
      // so it isn't shown twice.
      const regionCode = this.phoneUtil.getRegionCodeForNumber(parsed);
      const country = COUNTRIES.find((c) => c.isoCode === regionCode);
      const dialCode = country?.dialCode ?? callingCode;
      const areaCode = dialCode.startsWith(callingCode) ? dialCode.slice(callingCode.length) : '';
      if (areaCode && nationalNumber.startsWith(areaCode)) {
        nationalNumber = nationalNumber.slice(areaCode.length);
      }

      return `+${dialCode}-${nationalNumber}`;
    } catch {
      return phoneNumber;
    }
  }
}
